export interface UserProfile {
    firstName: string;
    lastName: string;
    fullName: string;
    userId: number;
    customerId: number;
    phoneNumber: string;
    userAccount: string;
    status: string;
    roles: Array<Role>;
}

interface Role {
    ApplicationId: number;
    roleCode: string;
    roleDesc: string;
    roleId: number;
    roleName: string;
    roleType: number;
}
